<div class="d-flex flex-column gap-3">
  <div>
    <apm-section-title title="{{ 457032 | apmTranslate }}"></apm-section-title>
    <apm-table
      gridId="chiller-free-st-evaporator"
      [persistColumnState]="true"
      [persistFilterState]="true"
      [rowData]="evaporatorRows()"
      [columnDefs]="evaporatorColumnDefs"
      [autoHeight]="true"
      [suppressRowClickSelection]="false"
      (selectionChanged)="onEvapSelected($event)"
      rowSelection="single"
      firstDataRenderedAction="sizeColumnsToFit"
    ></apm-table>
  </div>
  <div>
    <apm-section-title title="{{ 457033 | apmTranslate }}"></apm-section-title>
    <apm-table
      gridId="chiller-free-st-condenser"
      [persistColumnState]="true"
      [persistFilterState]="true"
      [rowData]="condenserRows()"
      [columnDefs]="condenserColumnDefs"
      [autoHeight]="true"
      [suppressRowClickSelection]="false"
      (selectionChanged)="onCondSelected($event)"
      rowSelection="single"
      firstDataRenderedAction="sizeColumnsToFit"
    ></apm-table>
  </div>
  <div>
    <apm-section-title title="{{ 25959 | apmTranslate }}"></apm-section-title>
    <apm-table
      gridId="chiller-free-st-compressor"
      [persistColumnState]="true"
      [persistFilterState]="true"
      [rowData]="compressorRows()"
      [columnDefs]="compressorColumnDefs"
      [autoHeight]="true"
      [suppressRowClickSelection]="false"
      (selectionChanged)="onCompSelected($event)"
      rowSelection="single"
      firstDataRenderedAction="sizeColumnsToFit"
    ></apm-table>
  </div>
</div>

<div class="d-flex justify-content-end mt-4">
  <apm-button class="min-w-lg" [disabled]="!allSelected()" (buttonClick)="generateDatasheet()">
    {{ 451849 | apmTranslate }}
  </apm-button>
</div>
